<template>
<!-- h3就是h3、h4就是h4、而li是1.5rem -->
  <div class="content">
    <div class="container">
      <Title :msg="topic.title"></Title>
      <div class="row m-auto">
        <div class="txt col col-12 col-md-6">
          <!-- <h3>{{ words.title }}</h3>
          <h4>{{ words.subtitle }}</h4> -->
          <!-- <ul>
            <li v-for="item in words.itemarray" :key="item">{{ item }}</li>
          </ul> -->
          <p class="text-justify">{{ words.content }}</p>
          <p class="text-justify">{{ words.summary }}</p>
        </div>
        <div class="picture col col-12 col-md-6">
          <div class="picture-inside">
            <img :src="words.picture" />
            <!-- <Button :msg="words.button"
            :btncolor="btncolor"
            @clickbutton="getDiscount"></Button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/title_nobg.vue';
// import Button from '@/components/only_button.vue';

export default {
  props: {
    topictitle: {
      listTitle: '這是第一個title',
    },
    listwords: {
      type: Object,
      default: () => ({
        title: '這裡是第一個標題',
        subtitle: '這裡是副標題',
        itemarray: [
          '這是第1點項目這是第1點項目',
          '這是第2點項目這是第2點項目',
          '這是第3點項目這是第3點項目',
          '這是第4點項目這是第4點項目',
          '這是第5點項目這是第5點項目',
          '這是第6點項目這是第6點項目',
          '這是第7點項目這是第7點項目',
          '這是第8點項目這是第8點項目',
        ],
        content: '',
        summary: '這裡是結論',
        picture: 'https://picsum.photos/500/500?random=14',
        button: '領取優惠',
      }),
    },
  },
  data() {
    return {
      topic: this.topictitle,
      words: this.listwords,
      btncolor: ['listPicture_area', 'hover-btn'], // 按鈕樣式設定class
    };
  },
  components: {
    Title,
    // Button,
  },
  methods:
  {
    getDiscount() {
      // console.log('點擊之後可以領取優惠');
      // eslint-disable-next-line no-alert
      window.alert('點擊之後可以領取優惠，但現在還沒有');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.content {
  margin: 70px auto;
  .container {
    .row {
      .txt {
        width: 60%;
        ul {
          margin: 30px 0px;
          padding: 0;
          list-style-position: inside;
          li {
            font-size: 1rem;
          }
        }
        p{
          font-size: 1.2rem;
        }
      }
      .picture {
        width: 40%;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-start;
        img {
          width: 100%;
          margin-bottom: 20px;
        }
      }
    }
  }
}
@media screen and (max-width: 600px){
  .content {
    .container {
      padding: 0;
    }
  }
}
</style>
